<template>
  <div class="text-xs-center">
    <v-menu v-model="menu" class="taskMenu" transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn icon flat class="mr-2" v-on="on" small @click="countTask">
          <v-badge overlap color="red">
            <template v-slot:badge>
              <span
                v-if="
                  getTarefasAtrasadas.length > 0 || getTarefasEmDia.length > 0
                "
                >{{ getTarefasAtrasadas.length + getTarefasEmDia.length }}</span
              >
            </template>
            <v-icon small color="grey lighten-1">far fa-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card>
        <v-subheader class="text-uppercase text-xs-left ml-2"
          >Tarefas</v-subheader
        >

        <v-chip
          :disabled="!activeAtrasados"
          small
          :color="activeAtrasados ? '#f2f2f2' : 'white'"
          class="ml-3"
          @click.stop="showAtrasadas"
        >
          <v-icon small left color="#f7776e">fas fa-clock</v-icon>
          {{ getTarefasAtrasadas.length }}
        </v-chip>

        <v-chip
          :disabled="!activeEmdia"
          small
          :color="activeEmdia ? '#f2f2f2' : 'white'"
          class="ml-1"
          @click.stop="showEmdia"
        >
          <v-icon small left color="#ffc266">fas fa-clock</v-icon>
          {{ getTarefasEmDia.length }}
        </v-chip>

        <v-chip
          :disabled="!activeConcluidas"
          small
          :color="activeConcluidas ? '#f2f2f2' : 'white'"
          class="ml-1"
          @click.stop="showConcluidas"
        >
          <v-icon small left color="#95d097">check</v-icon>
          {{ getTarefasConcluidas.length }}
        </v-chip>

        <v-divider class="mt-1"></v-divider>

        <v-list three-line>
          <v-list-tile v-if="filteredTasks.length == 0">
            <v-list-tile-content>
              <v-list-tile-sub-title class="ml-3"
                >Você não possui resultados</v-list-tile-sub-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <virtualList
            :size="96"
            :remain="filteredTasks.length < 5 ? filteredTasks.length : 5"
            ref="vlist"
          >
            <div v-for="(item, index) in filteredTasks" :key="index">
              <v-list-tile
                :class="`mx-3 mt-1 mb-1 ${item.situacao}`"
                class="animated fadeIn"
              >
                <v-list-tile-content @click="showDetails(item)">
                  <v-list-tile-title
                    >{{ item.person.nome }}
                    {{ item.person.sobrenome }}</v-list-tile-title
                  >

                  <v-list-tile-sub-title>{{
                    item.description
                  }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title class="mt-1"
                    >{{ item.due | formattedDate
                    }}<v-icon
                      class="ml-1"
                      small
                      :color="item.end ? '#95d097' : '#e0e0e0'"
                      @click.stop="updateStatus(item)"
                      >check</v-icon
                    ></v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>

              <v-divider
                v-if="index + 1 < filteredTasks.length"
                :key="index"
              ></v-divider>
            </div>
          </virtualList>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="createTask = true">
            <span class="text-lowercase">criar tarefa</span>
          </v-btn>
          <v-btn color="primary" flat to="/tarefas" @click="countExibirTodas">
            <span class="text-lowercase">Exibir todas</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <DetalhesTarefasModal v-model="taskDetails" />

    <CadastrarTarefa v-model="createTask" />
  </div>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list';
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/event-bus.js';
import pt from 'date-fns/locale/pt';
import format from 'date-fns/format';
import {
  distanceInWordsToNow,
  isFuture,
  isPast,
  endOfDay,
  addHours,
} from 'date-fns';

const api = new APIService();

export default {
  data: () => ({
    counterExibirTodas: 0,
    counterTaskDetails: 0,
    counterTask: 0,
    counterComplete: 0,
    menu: false,
    message: false,
    hints: true,
    createTask: false,
    taskDetails: false,
    active: { on: false },
    activeAtrasados: true,
    activeEmdia: true,
    activeConcluidas: false,
  }),

  methods: {
    countExibirTodas() {
      this.counterExibirTodas += 1;

      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Abrir Exibir Todas',
        eventValue: this.counterExibirTodas,
      });
    },
    countTask() {
      this.overlay = !this.overlay;
      this.counterTask += 1;

      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Abrir TaskBar',
        eventValue: this.counterTask,
      });
    },
    async showDetails(task) {
      this.counterTaskDetails += 1;

      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Abrir Detalhes Task',
        eventValue: this.counterTaskDetails,
      });

      await this.$store.commit('SET_SELECTEDTASK', task);
      await this.$store.dispatch('carregarContatoTask');
      this.taskDetails = true;
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Status alterado com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async updateStatus(item) {
      this.counterComplete += 1;

      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Completar Task',
        eventValue: this.counterComplete,
      });

      if (item.end) {
        item.end = null;
      } else {
        item.end = new Date();
      }

      api.updateTask(item);
      this.emitSnackBar();
    },
    isEmDia(value) {
      value.situacao = 'EMDIA';
      return !value.end && isFuture(endOfDay(addHours(value.due, 3)));
    },
    isAtrasado(value) {
      value.situacao = 'ATRASADO';
      return !value.end && isPast(endOfDay(addHours(value.due, 3)));
    },
    isConcluido(value) {
      value.situacao = 'CONCLUIDO';
      return value.end;
    },
    showConcluidas() {
      this.activeConcluidas = !this.activeConcluidas;
      if (this.activeConcluidas) {
        this.$refs.vlist.forceRender();
      } else {
        this.$refs.vlist.forceRender();
      }
    },
    showAtrasadas() {
      this.activeAtrasados = !this.activeAtrasados;
      this.$nextTick(() => {
        if (this.activeAtrasados) {
          this.$refs.vlist.forceRender();
        } else {
          this.$refs.vlist.forceRender();
        }
      });
    },
    showEmdia() {
      this.activeEmdia = !this.activeEmdia;
      this.$nextTick(() => {
        if (this.activeEmdia) {
          this.$refs.vlist.forceRender();
        } else {
          this.$refs.vlist.forceRender();
        }
      });
    },
  },
  filters: {
    formattedDate: item => distanceInWordsToNow(item, { addSuffix: true, locale: pt }),
  },
  computed: {
    ...mapState(['tasks']),
    ...mapGetters([
      'getTarefasConcluidas',
      'getTarefasEmDia',
      'getTarefasAtrasadas',
    ]),

    filteredTasks() {
      return this.$store.state.tasks.filter(
        el => (this.activeEmdia && this.isEmDia(el))
          || (this.activeAtrasados && this.isAtrasado(el))
          || (this.activeConcluidas && this.isConcluido(el)),
      );
    },
  },
  mounted() {},
};
</script>

<style scoped>
.v-menu__content--fixed {
  top: 58px !important;
  left: 0px !important;
  min-width: 100% !important;
  border-bottom: 2px solid #e0e0e0;
}
.v-menu__content {
  box-shadow: none !important;
}
.EMDIA {
  border-left: 3px solid #ffc266 !important;
}
.ATRASADO {
  border-left: 3px solid #f7776e !important;
}
.CONCLUIDO {
  border-left: 3px solid #95d097 !important;
}
</style>

<style>
.v-chip:focus:not(.v-chip--disabled),
.v-chip--active,
.v-chip--selected {
  box-shadow: none !important;
  background-color: #f2f2f2 !important;
}
</style>
